export const PAGE_TRANS_VARIANTS = {
  fadeSlideHorizontal: {
    name: "Fade + Slide Horizontal",
    variants: {
      initial: { opacity: 0, x: -20 },
      animate: { opacity: 1, x: 0 },
      exit: { opacity: 0, x: 20 },
    },
  },
  fadeSlideVertical: {
    name: "Fade + Slide Vertical",
    variants: {
      initial: { opacity: 0, y: 30 },
      animate: { opacity: 1, y: 0 },
      exit: { opacity: 0, y: -30 },
    },
  },
  fade: {
    name: "Fade Only",
    variants: {
      initial: { opacity: 0 },
      animate: { opacity: 1 },
      exit: { opacity: 0 },
    },
  },
  scaleFade: {
    name: "Scale + Fade",
    variants: {
      initial: { opacity: 0, scale: 0.95 },
      animate: { opacity: 1, scale: 1 },
      exit: { opacity: 0, scale: 0.95 },
    },
  },
  zoomInOut: {
    name: "Zoom In/Out",
    variants: {
      initial: { scale: 0.8, opacity: 0 },
      animate: { scale: 1, opacity: 1 },
      exit: { scale: 1.2, opacity: 0 },
    },
  },
};
